import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { ListItem } from './list-item'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { pushToGTM } from '../../../../../utils/pushToGTM'

interface Props {
  message: string
  items: any[]
  onItemSelected: (item: any) => void
  isMobile?: boolean
  revampEnabled?: boolean
}

export const List = ({
  message,
  items,
  onItemSelected,
  isMobile,
  revampEnabled = false,
}: Props) => (
  <div
    className={clsx(s.list, {
      [s.listRevamp]: revampEnabled,
      [s.mobile]: isMobile,
    })}
    style={{ backgroundColor: isMobile ? 'white' : '' }}
  >
    {message && <div className={s.message}>{message}</div>}
    {!message &&
      items.map((item) => (
        <ListItem
          key={item.place_id}
          item={item}
          onClick={(e: any) => {
            e.stopPropagation()
            onItemSelected(item)
            pushToGTM({
              event: 'LocationChoiceClick',
              selectedItem: item,
            })
            Mixpanel.track('LocationChoiceClick', { selectedItem: item })
          }}
          revampEnabled={revampEnabled}
        />
      ))}
  </div>
)
